import { Create, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";

const CreateSpecializations = () => {
  return (
    <Create
      title="Създаване"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateSpecializations;
